// Everything the platform mounts for billing, in one place.

import type { ModuleScreens } from "../../components/chrome/screens";
import { CreditCard } from "lucide-react";
import BillingIndex from "./pages/BillingIndex";
import InvoiceDetail from "./pages/InvoiceDetail";
import PaymentDetail from "./pages/PaymentDetail";
import PortalPayments from "./pages/PortalPayments";
import { BillingCard } from "./components/BillingCard";
import { ClientBillingTab } from "./components/ClientBillingTab";
import { NewInvoiceAction } from "./components/NewInvoiceAction";
import { StripeKeysSection } from "./components/StripeKeysSection";
import { PortalPaymentDue } from "./components/PortalPaymentDue";

export const billingScreens: ModuleScreens = {
  id: "billing",
  routes: [
    { path: "/billing", element: <BillingIndex />, wrapper: "chrome" },
    { path: "/billing/invoice/:invoiceId", element: <InvoiceDetail />, wrapper: "chrome" },
    { path: "/billing/payment/:paymentId", element: <PaymentDetail />, wrapper: "chrome" },
    { path: "/portal/payments", element: <PortalPayments />, wrapper: "portal" },
  ],
  // The firm's money is the admin's (the server refuses everyone else).
  tiles: [{ id: "billing", icon: "$", label: "Billing", to: "/billing", adminOnly: true }],
  trails: [{ path: "/billing", steps: [{ label: "Billing" }] }],
  matterPanels: [BillingCard],
  clientTabs: [{ key: "billing", label: "Billing", panel: ClientBillingTab }],
  clientActions: [NewInvoiceAction],
  integrationSettings: { stripe: () => <StripeKeysSection /> },
  portalTabs: [
    {
      to: "/portal/payments",
      label: "Payments",
      icon: <CreditCard strokeWidth={1.9} aria-hidden />,
    },
  ],
  portalCards: [PortalPaymentDue],
};
